@if (loadingService.isLoading()) {
<div
  class="fixed top-0 left-0 w-full h-full flex flex-col items-center justify-center z-1000 backdrop-blur-sm bg-secondary-500/30 font-thin overflow-hidden">
  <!-- Animated background elements -->
  <div class="absolute inset-0 overflow-hidden pointer-events-none">
    <div class="fitness-particle fitness-particle-1"></div>
    <div class="fitness-particle fitness-particle-2"></div>
    <div class="fitness-particle fitness-particle-3"></div>
    <div class="fitness-particle fitness-particle-4"></div>
  </div>

  <!-- Main loader content -->
  <div class="relative z-10 flex flex-col items-center">
    <!-- Animated icon container -->
    <div class="mb-4 relative">
      <!-- Brand name with improved animation -->
      <div class="inline-block leading-relaxed backdrop-blur-2xl px-4 py-4 rounded-lg inset-0 ">
        <span class="md:text-6xl text-4xl font-extrabold text-primary loader-text-one uppercase"> DENTIUM </span>
        <span class="md:text-6xl text-4xl font-bold text-secondary loader-text-two uppercase">
          SYS
        </span>
      </div>
      <!-- Pulsing circles behind -->
      <!-- <div class="pulse-ring pulse-ring-1 -z-10"></div>
            <div class="pulse-ring pulse-ring-2 -z-10"></div>
            <div class="pulse-ring pulse-ring-3 -z-10"></div> -->
    </div>

    <!-- Loading bar -->
    <div class="w-64 h-1 dark:bg-white/20 bg-black/20 rounded-full overflow-hidden mb-6">
      <div class="loading-bar h-full bg-gradient-to-r from-primary-500 to-primary-300"></div>
    </div>

    <!-- Messages -->
    <p class="dark:text-white text-black font-normal text-2xl text-center px-4 loader-fade-in">
      {{ loadingService.title() }}
    </p>
    @if (loadingService.message() != '') {
    <p class="dark:text-white text-black font-normal text-lg pt-2 text-center px-4 loader-fade-in-delayed">
      {{ loadingService.message()}}
    </p>
    }
  </div>
</div>
}